export default __webpack_public_path__ + "static/media/livechart.546dd938.png";